function dateKey(value) {
  if (!value) return '';
  const direct = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  if (direct) return direct[1];
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? '' : parsed.toISOString().slice(0, 10);
}

export function buildVisitTypeBillingContext(patient, clinicId) {
  const queueDate = dateKey(patient?.date);
  const visits = Array.isArray(patient?.visits) ? patient.visits : [];
  const currentVisit = [...visits].reverse().find((visit) => dateKey(visit?.date) === queueDate);

  return {
    clinic_id: clinicId || patient?.clinic_id || '',
    queue_date: queueDate,
    visit_id: currentVisit?.visit_id || '',
  };
}
